

class Empleado {
  constructor({
    id = null,
    nombre = '',

    uid = '',
    privilegio = 1,
    posicion = '',

    user_id = '',
    sucursal = '',
    cedula = '',
    turno_semanal = '',

  }) {
    this.id = id;
    this.nombre = nombre;

    this.uid = uid;
    this.privilegio = privilegio;
    this.posicion = posicion;

    this.user_id = user_id;

    this.sucursal = sucursal;
    this.cedula = cedula;
    this.turno_semanal = turno_semanal;


  }

  // Método para actualizar los datos de la empresa
  update(data) {
    Object.assign(this, data);
  }
}

export default Empleado;